/**
* Sticky element.
* 
* Kun scrollataan sivua, niin jos window.scrollY on suurempi kuin kyseisen elementin top + height,
* muutetaan elementti stickyksi antamalla sille sticky-luokka. Ei tehdä tyylejä inlinenä, koska joskus
* stickynä elementille tulee muitakin muutoksia kuin vain position:fixed.
*
* Ottaa myös huomioon headerin (joka on aina läsnä, fixed) korkeuden.
*
* stickFrom-attribuutilla voidaan kontrolloida, tapahtuuku stick event kun on saavutettu kyseisen
* alareuna vai yläreuna.
*
* Voidaan antaa myös callbackit, joita kutsutaan, kun sticky ja unsticky triggeröidään:
*
* - onSticky
* - onUnsticky
*
* Esimerkki:
*
* <div sticky-element stick-from="top" on-stick="SwitchToFixedMode()" on-unstick="SwitchToRelativeMode()"></div>
*/
app.directive('stickyElement', ["$rootScope", function($rootScope) {
	
	return {

		restrict: 'A',

		link: function(scope, element, attrs) {

			var header = $('.l-placeholder--header');

			var getHeaderHeight = function() {
				if(header.css('position') == 'fixed') {
					return header.height();
				} else {
					return 0;
				}
			};

			var $element = $(element);
			var headerHeight = getHeaderHeight();
			var extra = 0;

			if(attrs.stickFrom == 'bottom') {
				extra = $element.height();
			}

			var scrollThreshold = $element.offset().top + extra - headerHeight;

			$(window).on("scroll", function() {
				if(attrs.stickFrom == 'bottom') {
					extra = $element.height();
				}
				headerHeight = getHeaderHeight();
				scrollThreshold = $element.offset().top + extra - headerHeight;
				if(window.pageYOffset >= scrollThreshold && !$element.hasClass('sticky')) {
					$element.addClass('sticky');
					if(attrs.onStick !== undefined) {
						scope.$apply(function() {
							scope.$eval(attrs.onStick);
						});
					}
				}
				else if($element.hasClass('sticky') && window.pageYOffset < scrollThreshold) {
					$element.removeClass('sticky');
					if(attrs.onUnstick !== undefined) {
						scope.$apply(function() {
							scope.$eval(attrs.onUnstick);
						});
					}
				}
			});
 
		},

		controller: ["$scope", function($scope) {
			

		}]
	};

}]);
	
